import * as React from 'react';
import { IPlayWeather } from '../../../../../interfaces/IPlay';
import * as styles from '../Weather.css';
import { IColorTheme } from '../../../../../interfaces/IColorTheme';
import { ColorTranslator } from 'colortranslator';
import { DaySection } from './DaySection';

export interface IProps {
  forecast: IPlayWeather[];
  width: number;
  height: number;
  sizeUnit: number;
  colorTheme: IColorTheme;
  getDaySections: () => DaySection[];
}

export interface IState {
  daySections: DaySection[];
}

export class DayVerticalWeather extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = { daySections: undefined };
  }

  componentDidMount(): void {
    this.setState({ daySections: this.props.getDaySections() });
  }

  public render(): JSX.Element {
    const colortranslator = new ColorTranslator(this.props.colorTheme.textColor.toLocaleLowerCase());
    const borderColor = `rgba(${colortranslator.R}, ${colortranslator.G}, ${colortranslator.B}, .2)`;

    return (
      <div
        className={styles.IA_weatherWidgetContainerVertical}
        style={{
          backgroundColor: this.props.colorTheme.backgroundColor
        }}
      >
        {this.state.daySections?.length >= 4 && this.state.daySections.slice(0, 4).map((section, i) => {
          return <div
            className={styles.IA_weatherDayVertical}
            style={{
              marginTop: i === 0 ? this.props.sizeUnit * 5 : undefined,
              marginBottom: i === 3 ? this.props.sizeUnit * 5 : undefined,
              borderBottom: i !== 3 ? `${this.props.sizeUnit / 5}px solid ${borderColor}` : undefined,
              borderTop: i !== 0 ? `${this.props.sizeUnit / 5}px solid ${borderColor}` : undefined,
            }}
          >
            <div
              style={{
                fontSize: this.props.sizeUnit * 3,
                marginLeft: this.props.sizeUnit * 8,
                marginBottom: 0,
                color: this.props.colorTheme.textColor
              }}
            >
              {section.title}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "100%",
                alignItems: "center",
                marginLeft: "auto",
                marginRight: this.props.sizeUnit * 6
              }}
            >
              <div
                className={styles.IA_precipation}
                style={{
                  fontSize: this.props.sizeUnit * 2,
                  minWidth: this.props.sizeUnit * 6,
                  marginRight: this.props.sizeUnit * 3,
                  marginTop: 0,
                  marginBottom: 0
                }}
              >
                {section.weather?.precipitationAmount !== 0 ? `${Math.ceil(section.weather?.precipitationAmount)} mm` : " "}
              </div>
              <div
                style={{
                  fontSize: this.props.sizeUnit * 5,
                  marginTop: 0,
                  marginBottom: 0,
                  color: this.props.colorTheme.textColor,
                  marginRight: this.props.sizeUnit * 3
                }}
              >
                {`${section.weather.airTemperature.toFixed(0)}°`}
              </div>
              <img
                src={section.weather.iconUrl}
                alt=""
                style={{
                  width: this.props.height / 10
                }}
              />
            </div>
          </div>
        })}
      </div>
    );
  }
}